import { UNISON_PROJECT_TYPE_ID } from '@witmetrics/utils/constants';
import AlignersIcon from '@/icons/cases/AlignersIcon';
import OrthoIcon from '@/icons/cases/OrthoIcon';
import NightguardIcon from '@/icons/cases/NightguardIcon';
import OtherCaseIcon from '@/icons/cases/OtherCaseIcon';
import RetainersIcon from '@/icons/cases/RetainersIcon';
import VeneersIcon from '@/icons/cases/VeneersIcon';

const {
  ALIGNERS,
  BLEACHING_TRAY,
  NIGHTGUARD,
  OTHER,
  RETAINERS,
  ORTHO_MODELS,
  VENEERS,
} = UNISON_PROJECT_TYPE_ID;

export const ICONS = {
  [ALIGNERS]: AlignersIcon,
  [BLEACHING_TRAY]: RetainersIcon,
  [NIGHTGUARD]: NightguardIcon,
  [OTHER]: OtherCaseIcon,
  [RETAINERS]: RetainersIcon,
  [ORTHO_MODELS]: OrthoIcon,
  [VENEERS]: VeneersIcon,
} as const;
